import { modelRegistryModule } from '@/features/model-registry'
import { modelTrainingModule } from '@/features/model-training'
import type { AppModule } from '@/shared/modules'

/**
 * Static registry of product modules. Each capability change (fleet-monitoring, alerting, …)
 * adds its module here.
 *
 * Whether a registered module is active is decided per deployment by `config.enabledModules`.
 */
// Model Registry before Model Training: the order of the Model Management group in the sidebar.
export const moduleRegistry: readonly AppModule[] = [modelRegistryModule, modelTrainingModule]
